import React from 'react';
import WidgetContextMenu from './widget-context-menu';

export default function PersonalSpaceContextMenu({ organization, personal_space }) {
    return (
        <WidgetContextMenu
            context={personal_space}
            usages={['personal_space']}
            organization={organization}
            footerCtaLabel="ticket.personal_spaces.menu.footer_cta"
            goBackLabel="ticket.personal_spaces.menu.go_back"
        />
    );
}
